export default __webpack_public_path__ + "static/media/instagram.02d3e3a0.svg";